<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="reportData.IsSummary ? fieldsSummary : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'TotalMileage',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        width: 90,
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
      }, {
        dataField: 'CityMileageKm',
        caption: 'Городской пробег, км',
      }, {
        dataField: 'CountryMileageKm',
        caption: 'Загородный пробег, км',
      }, {
        dataField: 'MileageKm',
        caption: 'Общий пробег, км',
      }],
      fieldsSummary: [{
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'ObjectName',
        alignment: 'center',
        caption: 'Объект',
      }, {
        dataField: 'SumCityMileageKm',
        caption: 'Городской пробег, км',
      }, {
        dataField: 'SumCountryMileageKm',
        caption: 'Загородный пробег, км',
      }, {
        dataField: 'SumMileageKm',
        caption: 'Общий пробег, км',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'SumCityMileageKm',
        name: 'CityMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumCountryMileageKm',
        name: 'CountryMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumMileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'CityMileageKm',
        name: 'CityMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'CountryMileageKm',
        name: 'CountryMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'MileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      reportSummary: [],
      sortableField: null,
      summary: null,
    };
  },
  watch: {
    reportData (value) {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
  },
  methods: {
    convertSummaryData (data) {
      this.reportSummary = data.Data.Data.map((x, i) => ({ ...x, RowNum: i + 1 }));
    },

    getSummary () {
      this.summary = {
        calculateCustomSummary: (options) => {
          if (options.summaryProcess === 'finalize') {
            const value = options;
            const totalValue = this.reportData.IsSummary ? this.reportData.Data[`Sum${options.name}`] : this.reportData.Data.Data[`Sum${options.name}`];
            if (totalValue !== undefined) {
              value.totalValue = totalValue;
            }
          }
        },
        totalItems: this.summaryColoumn,
      };
    },
  },
};
</script>
